import { inject, Pipe, PipeTransform } from '@angular/core';
import { Url } from '@app/models/global.model';
import { AuthService } from '@app/services/auth.service';

@Pipe({
  name: 'calcCta',
  standalone: true,
})
export class CalcCtaPipe implements PipeTransform {
  #auth = inject(AuthService);

  transform(url?: Url, authUrl?: Url): Url | undefined {
    if (!authUrl || !this.#auth.isAuthenticated()) return url;
    if (url) authUrl.title = url.title;
    return authUrl;
  }
}
